import Vue from 'vue'
//兼容桌面端mounse事件
import '@vant/touch-emulator'
import {
  Button,
  Field,
  Form,
  Tabbar,
  TabbarItem,
  Icon,
  Sticky,
  Tabs,
  Tab,
  Collapse,
  CollapseItem,
  Rate,
  Checkbox,
  CountDown,
  DatetimePicker,
  Picker,
  Skeleton,
  Swipe,
  SwipeItem,
  PasswordInput,
  NumberKeyboard,
  ActionSheet,
  List,
  Stepper,
  Search,
  DropdownItem,
  DropdownMenu,
  Popup,
  Notify, // 轻提示
  Toast, // 轻提示
  Dialog, // 重提示 弹窗
  Overlay, // 遮罩
  Loading,
  CellGroup,
  Cell,
  Tag,
  Row,
  Col,
  Image,
  ImagePreview,
  Circle,
  PullRefresh,
  Lazyload,
  Calendar,
  NavBar,
  Switch,
  Slider,
  Empty,
  Popover,
  NoticeBar,
  IndexBar,
  IndexAnchor,
  RadioGroup,
  Radio,
  Sidebar,
  SidebarItem,
  Uploader,
  Progress,
  Area,
  Badge
} from 'vant'

Vue.use(Button)
Vue.use(Field)
Vue.use(Form)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)
Vue.use(Sticky)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Rate)
Vue.use(Checkbox)
Vue.use(CountDown)
Vue.use(DatetimePicker)
Vue.use(Picker)
Vue.use(Skeleton)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(ActionSheet)
Vue.use(Stepper)
Vue.use(Search)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Popup)
Vue.use(List)
Vue.use(Notify)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Overlay)
Vue.use(Loading)
Vue.use(CellGroup)
Vue.use(Cell)
Vue.use(Tag)
Vue.use(Row)
Vue.use(Col)
Vue.use(Image)
Vue.use(ImagePreview)
Vue.use(Circle)
Vue.use(PullRefresh)
Vue.use(Lazyload)
Vue.use(Calendar)
Vue.use(NavBar)
Vue.use(Switch)
Vue.use(Slider)
Vue.use(Empty)
Vue.use(Popover)
Vue.use(NoticeBar)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Uploader)
Vue.use(Progress)
Vue.use(Area)
Vue.use(Badge)

// 配置toast默认项
Toast.setDefaultOptions({
  duration: 2000
})

Toast.setDefaultOptions('loading', {
  forbidClick: true,
  duration: 0,
  loadingType: 'spinner'
})
